import React from 'react';
import { Link } from 'react-router-dom';
import { Waves, ArrowRight } from 'lucide-react';
import { promoVideoUrl } from '../../data/mock';

export default function PoolPromise() {
  return (
    <section className="relative py-24 bg-splash-green text-splash-cream overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <svg viewBox="0 0 800 200" preserveAspectRatio="none" className="w-full h-full">
          <path d="M0,100 C150,150 350,50 500,100 C650,150 750,80 800,100 L800,200 L0,200 Z" fill="#4BB5C1" />
          <path d="M0,130 C150,180 350,80 500,130 C650,180 750,110 800,130 L800,200 L0,200 Z" fill="#E89B8B" opacity="0.4" />
        </svg>
      </div>
      <div className="relative max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 uppercase tracking-widest text-splash-coral text-xs font-semibold mb-4">
            <Waves className="w-3.5 h-3.5" /> One Class at a Time
          </div>
          <h2 className="font-display font-bold text-4xl md:text-5xl leading-tight">Your little one's class enjoys the entire pool.</h2>
          <p className="mt-6 text-splash-cream/80 text-lg leading-relaxed">
            A peaceful, distraction-free lesson. This quiet environment helps children feel safe and stay focused so they can absorb every new skill.
          </p>
          <Link
            to="/programs"
            data-testid="pool-promise-view-programs"
            className="inline-flex items-center gap-2 mt-8 rounded-full bg-splash-coral hover:bg-splash-coralDark text-white px-6 py-3 font-semibold btn-transition"
          >
            View Programs <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="relative">
          <div className="aspect-video rounded-3xl overflow-hidden border border-white/10 shadow-2xl bg-black">
            <video
              src={promoVideoUrl}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
